"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var __1 = require("..");
var react_1 = require("@emotion/react");
var defaultProps = {
    checked: false,
    disabled: false,
    align: 'center',
};
var getCSSRules = function (_a, props) {
    var colors = _a.colors;
    return ({
        wrapper: {
            display: 'inline-flex',
            alignItems: props.align === 'center' ? 'center' : 'flex-start',
            cursor: props.disabled ? 'default' : 'pointer',
            userSelect: 'none',
            pointerEvents: props.disabled ? 'none' : 'auto',
        },
        radio: {
            cursor: props.disabled ? 'default' : 'pointer',
            boxSizing: 'border-box',
            borderRadius: '50%',
            display: 'inline-block',
            flexShrink: 0,
            width: 16,
            height: 16,
            textAlign: 'center',
            border: "1px solid ".concat(colors.Grey[props.disabled ? 400 : 500]),
            '&:hover': {
                borderColor: colors.Grey[props.disabled ? 400 : 600],
            },
        },
        active: {
            backgroundColor: !props.disabled ? colors.Hannibal[600] : undefined,
            border: 'none',
        },
        input: {
            display: 'none',
        },
        check: {
            width: 8,
            height: 8,
            margin: 4,
            backgroundColor: colors.Grey[0],
            borderRadius: '50%',
            boxSizing: 'border-box',
        },
        label: {
            marginLeft: 8,
        },
    });
};
var Check = function (props) {
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, props);
    return (0, jsx_runtime_1.jsx)("div", { css: styles.check }, void 0);
};
var Radio = function (props) {
    var checked = props.checked, label = props.label, style = props.style, className = props.className, rest = __rest(props, ["checked", "label", "style", "className"]);
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, props);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var _b;
            var cx = _a.cx, css = _a.css;
            return ((0, jsx_runtime_1.jsxs)("label", __assign({ className: cx(css(styles.wrapper), className), style: style }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: cx(css(styles.radio), (_b = {},
                            _b[css(styles.active)] = checked,
                            _b)) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ type: "radio", checked: checked, css: styles.input, onChange: function () { return props.handleInputChange(props.value); } }, rest), void 0), checked && (0, jsx_runtime_1.jsx)(Check, __assign({}, rest), void 0)] }), void 0), label &&
                        (typeof label === 'string' ? ((0, jsx_runtime_1.jsx)(__1.Typography, __assign({ variant: 'textMedium', css: styles.label, color: props.disabled ? 'Grey@400' : 'Grey@900' }, { children: label }), void 0)) : (label))] }), void 0));
        } }, void 0));
};
Radio.defaultProps = defaultProps;
exports.default = Radio;
//# sourceMappingURL=Radio.js.map